import { HeaderButton } from '@/components/HeaderButton';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import SingUpModal from '@/components/Modals/SingUpModal';
import Plus from '@/images/plus.svg';
import { useAnalytics } from '@/services/analytics';
import { useAuth } from '@/services/auth';
import { AppRoutes } from '@/utils/types';
import { useTheme } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const CreateButton = () => {
    const mixpanel = useAnalytics();
    const navigate = useNavigate();
    const theme = useTheme();
    const { isAnonymous } = useAuth();
    const [showSignupModal, setShowSignupModal] = useState(false);

    const handleClick = () => {
        mixpanel?.track('campaigns-create', {
            event: 'click',
            from: 'top',
        });

        if (isAnonymous) {
            setShowSignupModal(true);
            return;
        }

        navigate(AppRoutes.CampaignCreate);
    };

    return (
        <>
            {showSignupModal && (
                <SingUpModal
                    text="Sign up to create a campaign"
                    mainText="Create an account to start creating campaigns and unlock additional features."
                    from="translations"
                    isOpen
                    onClose={() => {
                        setShowSignupModal(false);
                    }}
                />
            )}

            <HeaderButton
                id="create_campaign-btn"
                onClick={handleClick}
                aria-label="create campaign"
                loadingText="Create campaign"
                style={{ marginLeft: 'auto' }}>
                <MaskedIcon color={theme.colors.black.main} src={Plus} size="16px" />
                Create campaign
            </HeaderButton>
        </>
    );
};
